/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Curly_Odd_Jurgen_SavorInputs */

const fr_curly_odd_jurgen_savor = /** @type {(inputs: Curly_Odd_Jurgen_SavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valider`)
};

/**

* @param {Curly_Odd_Jurgen_SavorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const curly_odd_jurgen_savor = /** @type {((inputs?: Curly_Odd_Jurgen_SavorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Curly_Odd_Jurgen_SavorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_curly_odd_jurgen_savor(inputs)
});